import React from 'react';
import { useTranslation } from 'react-i18next';
import { List, Image } from '@chakra-ui/react';

type Props = {};

export const Edge = (props: Props) => {
    const { t } = useTranslation();
    return (
        <List.Root as="ol" listStyle="decimal" marginLeft={4}>
            <List.Item _marker={{ color: 'inherit' }}>{t('operatingInstructionsScreen.edge.one')}</List.Item>
            <List.Item _marker={{ color: 'inherit' }}>{t('operatingInstructionsScreen.edge.two')}</List.Item>
            <List.Item _marker={{ color: 'inherit' }}>{t('operatingInstructionsScreen.edge.three')}</List.Item>
            <Image src="/img/edge/screen.png" marginTop={4} marginBottom={4} alt="image" />
            <List.Item _marker={{ color: 'red' }} color="red">
                {t('operatingInstructionsScreen.edge.four')}
            </List.Item>
            <List.Item _marker={{ color: 'red' }} color="red">
                {t('operatingInstructionsScreen.edge.five')}
            </List.Item>
            <List.Item _marker={{ color: 'red' }} color="red">
                {t('operatingInstructionsScreen.edge.six')}
            </List.Item>
        </List.Root>
    );
};
